module.exports = __webpack_public_path__ + "static/media/generate visitor card.f75f3478.svg";